import { Box, CircularProgress, Typography } from '@mui/material';
import {
  useGetPresignedUrl,
  useGetPricingDashboardDocuments,
} from '../../api/documentHub.ts';
import { DocumentTypes } from '../../models/documentHub.tsx';
import { useTitle } from '../../hooks/useTitle.ts';
import { PDFViewer } from '../../components/pdf-viewer/pdf-viewer.tsx';
import './pricing-dashboard.scss';

export const PricingDashboardView = () => {
  useTitle('Pricing Dashboard - Immersive Homes');

  const { data: pricingDashboardDocumentsData, loading } =
    useGetPricingDashboardDocuments();

  const { preSignedUrl } = useGetPresignedUrl({
    name:
      pricingDashboardDocumentsData?.['pricing-dashboard'][0]?.documentName ||
      '',
    type: DocumentTypes.PRICING_DASHBOARD,
  });

  return (
    <>
      {!preSignedUrl && !loading ? (
        <Box className="pdf-viewer">
          <Box className="no-results">
            <Typography className="no-results-text">
              No Pricing Document Found
            </Typography>
          </Box>
        </Box>
      ) : preSignedUrl ? (
        <PDFViewer url={preSignedUrl} />
      ) : (
        <Box className="loading">
          <CircularProgress sx={{ marginRight: '12px' }} />
          <Typography>Loading...</Typography>{' '}
        </Box>
      )}
    </>
  );
};
